function eventMessage(event, hint) {
    var _a, _b, _c, _d, _e, _f;
    return [
        event === null || event === void 0 ? void 0 : event.message,
        (_c = (_b = (_a = event === null || event === void 0 ? void 0 : event.exception) === null || _a === void 0 ? void 0 : _a.values) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.value,
        (_f = (_e = (_d = event === null || event === void 0 ? void 0 : event.exception) === null || _d === void 0 ? void 0 : _d.values) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.type,
        (hint === null || hint === void 0 ? void 0 : hint.originalException) && typeof hint.originalException === 'object' ? hint.originalException.message : undefined,
        String((hint === null || hint === void 0 ? void 0 : hint.originalException) || '')
    ].filter(Boolean).join('\n');
}
function eventBrowserNames(event) {
    var _a, _b;
    const contexts = event.contexts;
    const tagBrowserNames = ((_a = event.tags) === null || _a === void 0 ? void 0 : _a.filter(tag => tag.key === 'browser' || tag.key === 'browser.name').map(tag => tag.value).filter(Boolean)) || [];
    return [
        (_b = contexts === null || contexts === void 0 ? void 0 : contexts.browser) === null || _b === void 0 ? void 0 : _b.name,
        ...tagBrowserNames
    ].filter(Boolean).join('\n');
}
export function isKnownExternalBrowserNoise(event, hint) {
    const message = eventMessage(event, hint);
    const browserNames = eventBrowserNames(event);
    return [
        'Invalid call to runtime.sendMessage(). Tab not found.',
        'Failed to connect to MetaMask',
        'MetaMask extension not found',
        'window.ethereum.selectedAddress',
        "Can't find variable: __firefox__",
        'window.__firefox__.reader',
        'Non-Error promise rejection captured with value: undefined',
        'Blob is not a constructor',
        'ResizeObserver loop completed with undelivered notifications',
        'Loading CSS chunk',
        'Loading chunk',
        'Importing a module script failed'
    ].some(pattern => message.includes(pattern)) ||
        (message.includes('invalid origin') && browserNames.includes('DuckDuckGo'));
}
export function scrubSensitivePasswordResetData(event) {
    var _a, _b;
    const sensitiveKeys = ['password', 'password_confirmation', 'passwordConfirmation', 'reset_token', 'resetToken'];
    const scrubObject = (value) => {
        if (!value || typeof value !== 'object')
            return;
        const record = value;
        Object.keys(record).forEach(key => {
            if (sensitiveKeys.includes(key)) {
                record[key] = '[Filtered]';
            }
            else {
                scrubObject(record[key]);
            }
        });
    };
    scrubObject((_a = event.request) === null || _a === void 0 ? void 0 : _a.data);
    scrubObject((_b = event.request) === null || _b === void 0 ? void 0 : _b.query_string);
    scrubObject(event.contexts);
    scrubObject(event.extra);
    return event;
}
